import React, { Component } from "react";
import "./LoginScreen.styles.scss";
import Button from "@material-ui/core/Button";
import { connect } from "react-redux";
import AuthMiddleware from "../../store/middleware/authMiddleware";
import Login_bg_1 from "../../assets/images/login-bg-1.png";
import login_unilever_2 from "../../assets/images/login-unilever-2.svg";
import CustomToast from "../../util-functions/customToast.jsx";

class LoginScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      username: "",
      password: "",
      isLoggedIn: false,
      isLoading: false,
    };
  }
  handleLogin = (e) => {
    // e.preventDefault();
    const { username, password } = this.state;
    if (username && password) {
      this.props.authenticate(username, password, this.props.history);
    } else {
      // ToastsStore.error('Username or Password is empty!')
      CustomToast("error", "Username or Password is empty!");
    }
  };

  handleChange = (e) => {
    let nam = e.target.name;
    let val = e.target.value;
    this.setState({
      [nam]: val,
    });
  };

  handleEnter = (e) => {
    if (e.keyCode === 13) {
      e.preventDefault();
      // const { username, password } = this.state;
      // this.props.authenticate(username, password, this.props.history);
      this.handleLogin();
    }
  };

  render() {
    const { username, password } = this.state;
    return (
      <div className="container-fluid main-login-container">
        <div className=" main-login">
          <div className=" login-container-left">
            <div className="login-bg-1">
              <img src={Login_bg_1} alt="" />
              <div className="login-bg-2">
                <img src={login_unilever_2} alt="" />
              </div>
            </div>
          </div>
          <div className=" login-container-right">
            <div className="login-right-div">
              <h5>
                Forecasting, <br />
                Promotion Management <br /> & Analytics
              </h5>
              <div className="login-textfields">
                <label>Email</label>
                <input
                  name="username"
                  value={username}
                  onChange={(e) => this.handleChange(e)}
                  onKeyDown={(e) => this.handleEnter(e)}
                  placeholder="User ID"
                  required
                ></input>
                <label>Password</label>
                <input
                  type="password"
                  name="password"
                  value={password}
                  onKeyDown={(e) => this.handleEnter(e)}
                  onChange={(e) => this.handleChange(e)}
                  placeholder="Password"
                  required
                ></input>
                <Button
                  variant="outlined"
                  className="login-btn"
                  onClick={(e) => this.handleLogin(e)}
                  disabled={this.props.isLoading}
                >
                  {this.props.isLoading ? "Login..." : "Login"}
                </Button>

                <a className='customer-portal-link' href='https://nxd.atlassian.net/servicedesk/customer/portals' rel="noopener noreferrer" target='_blank'>
                  Customer Portal
                </a>
              </div>
           
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isLoading: state.AuthReducer.isLoading,
  };
};

const mapDispatchToprops = (dispatch) => {
  return {
    authenticate: (username, password, history) => {
      dispatch(AuthMiddleware.authenticate(username, password, history));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToprops)(LoginScreen);
